module.exports = __webpack_public_path__ + "static/media/cat1.535549bf.jpg";